const getAffiliateIdUrl = (url, id) => {
    return url && id ? `${url}?affiliateId=${id}` : url;
};

export default getAffiliateIdUrl;
